// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1Qoqy","content":"Footer_content__2mF8h","link":"Footer_link__3Ml-A"};